{
  "secretary": {
    "navLabel": "Intelligente Assistenz",
    "title": "{{brand}} intelligente Assistenz",
    "recorder": {
      "record": "Sagen Sie einen Befehl — z. B. „Termin für Rezaei morgen um zehn“",
      "recording": "Ich höre zu…",
      "stop": "Stoppen und ausführen",
      "discard": "Verwerfen",
      "processing": "Die Assistenz arbeitet…",
      "warn": {
        "nothing": "Ich habe nichts gehört",
        "busy": "Die Assistenz ist noch mit dem letzten Befehl beschäftigt",
        "mic": {
          "denied": "Der Mikrofonzugriff wurde nicht erlaubt",
          "unsupported": "Dieser Browser kann keinen Ton aufnehmen",
          "error": "Das Mikrofon ließ sich nicht öffnen"
        }
      }
    },
    "notice": {
      "listLabel": "Ergebnisse der intelligenten Assistenz",
      "heard": "Gehört: „{{text}}“",
      "dismiss": "Schließen",
      "more": "{{count}} weitere",
      "open": "Öffnen",
      "bookReady": "Termin für {{name}} ist bereit",
      "followUpReady": "Nachkontrolle für {{name}} ist bereit",
      "slotLine": "{{day}}, {{time}}",
      "slotLineClinic": "{{day}}, {{time}} — {{clinic}}",
      "noSlot": "Kein freier Termin gefunden",
      "choosePatient": "Welche(r) „{{name}}“?",
      "candidates": "{{count}} Patienten mit diesem Namen",
      "notFound": "„{{name}}“ ist nicht unter Ihren Patienten",
      "openRecord": "Akte von {{name}}",
      "daySummary": "Sie haben heute {{total}} Termine",
      "noClinic": "Sie haben keine Klinik, in der Sie buchen können",
      "outOfScope": "Das übernimmt die Assistenz nicht",
      "unavailable": "Der heutige Plan konnte nicht gelesen werden",
      "unknown": "Ich habe nicht verstanden",
      "failed": "Die Assistenz konnte es nicht ausführen",
      "noCredit": "Nicht genug {{coin}}"
    },
    "window": {
      "close": "Schließen",
      "recordAgain": "Noch einmal sagen",
      "heard": "Gehört",
      "openForm": "Terminformular öffnen",
      "pickSlot": "Wählen Sie einen dieser Termine; das Formular öffnet sich damit ausgefüllt.",
      "hourTaken": "{{time}} ist belegt; die nächsten freien Zeiten:",
      "hourFree": "{{time}} ist frei.",
      "slot": "{{day}}, {{time}}",
      "requestOnly": "Diese Klinik hat die Direktbuchung geschlossen; der Termin wird als Anfrage an den Empfang zur Bestätigung gesendet.",
      "noSlotLine": "Für {{name}} wurde in diesem Zeitraum kein freier Termin gefunden. Sie können das Formular öffnen und einen anderen Tag wählen.",
      "choosePatientLine": "Mehrere Ihrer Patienten haben einen ähnlichen Namen wie „{{name}}“. Welche(r)?",
      "newPatient": "Neue(r) Patient(in)",
      "file": "Akte {{file}}",
      "age": "{{age}} J.",
      "phoneTail": "Mobil …{{tail}}",
      "notFoundLine": "Unter den Patienten Ihrer Kliniken wurde niemand namens „{{name}}“ gefunden.",
      "closest": "Ähnlichste Namen:",
      "noClinicTitle": "Sie haben noch keine Klinik",
      "noClinicLine": "Um Termine zu buchen, müssen Sie Mitglied einer Klinik sein oder Ihre eigene Praxis anlegen. Akten öffnen und den heutigen Plan nennen kann die Assistenz trotzdem.",
      "readOnlyTitle": "Die Abonnements Ihrer Kliniken sind abgelaufen",
      "readOnlyLine": "In einer Klinik kann nichts gebucht werden, bis sie ihr Abonnement verlängert.",
      "goReception": "Zum Empfang",
      "dayTitle": "Sie haben heute {{total}} Termine",
      "dayCounts": "{{completed}} erledigt · {{arrived}} anwesend · {{scheduled}} wartend",
      "dayRequested": "{{count}} Anfragen warten auf die Klinik",
      "dayNext": "Als Nächstes:",
      "dayNone": "Heute steht nichts mehr an.",
      "noHour": "Ohne Termin",
      "unknownPatient": "Patient(in)",
      "status": {
        "scheduled": "Wartend",
        "requested": "Wartet auf die Klinik",
        "arrived": "Anwesend",
        "in_visit": "In Behandlung"
      },
      "outOfScopeTitle": "Das übernimmt die Assistenz nicht",
      "topic": {
        "clinical_record": "Rezepte, Diagnosen und Notizen schreiben Sie im Besuch selbst.",
        "visit_flow": "Besuche starten und enden über den Empfang und den Besuch selbst.",
        "mark_arrived": "Die Anwesenheit erfasst der Empfang der Klinik.",
        "reschedule_or_cancel": "Um einen Termin zu verschieben oder abzusagen, öffnen Sie ihn im Empfang.",
        "money": "Finanzielles finden Sie unter Buchhaltung.",
        "send_message": "Nachrichten an Patienten senden Sie unter Nachrichten.",
        "delete_record": "Die Assistenz löscht niemals etwas.",
        "other": "Die Assistenz bereitet Termine und Nachkontrollen vor, öffnet Akten und nennt den heutigen Plan."
      },
      "unavailableLine": "Der heutige Plan konnte gerade nicht gelesen werden. Fragen Sie gleich noch einmal.",
      "unknownLine": "Die Assistenz kann Termine und Nachkontrollen vorbereiten, eine Akte öffnen und den heutigen Plan nennen.",
      "failedLine": "Sagen Sie es noch einmal. Wiederholt es sich, erledigen Sie es auf der zugehörigen Seite.",
      "noCreditLine": "Laden Sie Ihre {{coin}} auf, um die Assistenz zu nutzen.",
      "topUp": "{{coin}} aufladen",
      "charged": "Für diesen Befehl wurden {{coin}} abgebucht.",
      "notCharged": "Für diesen Befehl wurden keine {{coin}} abgebucht."
    },
    "form": {
      "notice": "Die intelligente Assistenz hat dieses Formular nach Ihren Worten ausgefüllt; prüfen Sie es vor der Buchung.",
      "reception_clinic": "Klinik: die im Empfang gewählte.",
      "working_hours": "Die Klinik wurde nach Ihren Sprechzeiten gewählt.",
      "earliest_free": "Die Klinik mit dem frühesten freien Termin wurde gewählt.",
      "newPatient": "Neue(r) Patient(in): die Akte wird bei der Buchung angelegt.",
      "heardPhone": "Gehörte Nummer: {{phone}}",
      "booked": "Termin gebucht.",
      "requested": "Terminanfrage zur Bestätigung an die Klinik gesendet."
    }
  }
}
